import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { offer } from '../data/offer';
export function StickyCTABar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-202" data-mp="1m0nvd0p8d8x4">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-sand bg-brand-alt/95 px-4 py-3 shadow-[0_-8px_24px_rgba(15,74,95,0.12)] backdrop-blur" data-id="element-203" data-mp="1m0w54jq23y43">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4" data-id="element-204" data-mp="m04f425p2fn">
            <div className="min-w-0" data-id="element-205" data-mp="hwfc7ep61acq">
              <p className="truncate text-xs font-bold text-brand-deep" data-id="element-206" data-mp="hxgkxciplkra">GEOGRAFIA PRONTA™ — 8 volumi + 5 bonus</p>
              <p className="flex items-baseline gap-2 text-sm" data-id="element-207" data-mp="lvxvk61c9ddg">
                <span className="font-display text-xl font-extrabold text-brand-deep" data-id="element-208" data-mp="7xprzf9srdtb">{offer.todayPrice}</span>
                <span className="text-xs font-semibold text-brand-gray line-through" data-id="element-209" data-mp="cw145wnke0ep">{offer.totalValue}</span>
              </p>
            </div>
            <CTAButton attention={false} className="shrink-0 px-5 py-3 text-xs sm:text-sm" data-id="element-210" data-mp="2z64vbjgvvzd">
              Acquista adesso
            </CTAButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}